<template>
  <div id="init-home-container" class="d-flex background_color">
    <!--//@*/*
    //    *RPD Records pages App v0.91
    //    * Copyright (c) 2023, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <!-- <auth></auth> -->

    <v-spacer></v-spacer>

    <v-main id="home-main" style="padding: 0 !important">
      <titlecard :title_text="'RECORDS DIVISION'"></titlecard>
      <!-- top card with color bar -->
      <top_card :descr_text="descr_text" :welcome="'Welcome'"></top_card>

      <v-container class="background_color black--text" id="home-container">
        <template>
          <div id="big-card" class="d-flex justify-center align-center">
            <v-card
              id="home-content-area"
              class="mb-16 pt-4"
              color="white"
              elevation="4"
              outlined
            >
              <!-- <v-layout row>
                <v-flex xs12 sm3 md3>
                  <v-img src="../images/endless_files512.png"></v-img>
                </v-flex>
                <v-flex xs12 sm9 md9>
                  <div style="width: 100%" class="pa-4">
                    <p class="text-h3-md text-h3-sm text-h5">RECORDS SECTION</p>
                    <p class="text-h4-md text-h4-sm text-h6">Welcome</p>
                    <p class="text-h6-md text-h6-sm text-body2">
                      The Records Division is responsible for maintaining
                      internal document control over all original reports,
                      including all crime, arrest and traffic accident reports
                      which are received by the Department. This Division's
                      personnel provide copy distribution, confirmation of
                      warrants and dissemination of documents and information
                      per court order, state statute, and internal policy.
                    </p>
                  </div>
                </v-flex>
              </v-layout> -->
              <div
                id="contains-expansions-layout"
                class="d-flex justify-center"
              >
                <v-expansion-panels id="all-panels" accordion>
                  <!-- public request -->
                  <rec_pub_recs_req
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></rec_pub_recs_req>

                  <!-- TRAFFIC ACCIDENT REPORT LIBRARY
(SEARCH FOR A TRAFFIC ACCIDENT REPORT WITHOUT SUBMITTING A NEW REQUEST) -->
                  <rec_traff_rpt_lib
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></rec_traff_rpt_lib>

                  <!-- rec_workcards_link -->
                  <rec_workcards_link
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></rec_workcards_link>

                  <!-- DOCUMENT RETRIEVAL GUIDE -->
                  <rec_doc_ret_guide
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></rec_doc_ret_guide>

                  <!-- CHECK ON WARRANT STATUS -->
                  <rec_warrant_status
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></rec_warrant_status>

                  <!-- ALARM STATUS -->
                  <rec_city_alarm
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></rec_city_alarm>

                  <!-- CRIMINAL HISTORY/EMBASSY LETTER  -->
                  <rec_crmnl_hstry
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></rec_crmnl_hstry>

                  <!-- DISPATCH RECORDS/CALLS FOR SERVICE/911 CALL REQUESTS  -->
                  <rec_dptch_rcrds
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></rec_dptch_rcrds>

                  <!-- FEDERAL BUREAU OF INVESTIGATION (FBI) CRIME DATA EXPLORER -->
                  <rec_fbi_cde
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></rec_fbi_cde>

                  <!-- RECORDS FEE SCHEDULE -->
                  <rec_fee_schdl
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></rec_fee_schdl>

                  <!-- RECORDS SECTION PHONE NUMBER/HOURS OF OPERATION -->
                  <rec_phn_num_hrs
                    @onExpansionPanelClick="onExpansionPanelClick"
                  ></rec_phn_num_hrs>

                  <!-- rec_faq -->
                  <rec_faq>
                    @onExpansionPanelClick="onExpansionPanelClick"
                  </rec_faq>
                </v-expansion-panels>
              </div>
            </v-card>
          </div>
        </template>
      </v-container>
    </v-main>
    <v-spacer></v-spacer>
    <v-btn
      id="fabup"
      ref="fabup"
      @click.prevent="fabup"
      title="Top of page"
      class="fabup"
      elevation="2"
      fab
      color="yellow accent-2"
    >
      <v-icon color="black" dark x-large> $chevup </v-icon>
    </v-btn>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .fabup {
    position: fixed;
    left: 85%;
    top: 90%;
    z-index: 500;
  }
  .topbar {
    width: 100%;
    height: 18px;
    background-color: #708e92;
  }
  a {
    color: blue;
  }
  #all-panels {
    width: 90%;
  }
  .v-main {
    padding: 0 !important;
  }

  .theme--light.v-expansion-panels .v-expansion-panel {
    color: white;
  }

  .results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap,
  .recent .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 7px !important;
  }
  .bcs-expansion-content {
    color: black;
  }
  .alice {
    color: aliceblue;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .fabup {
    position: fixed;
    left: 95%;
    top: 90%;
  }
  .basic-interior-card {
    min-height: 200px;
  }
  #init-home-container {
    width: 100%;
  }
  #home-container {
    width: 100vw;

    height: auto;
    position: relative;
    top: 0px;
  }
  #home-content-area {
    width: 100%;
    max-width: 85%;
    height: auto;
    background-color: white;
  }
  #top-card-content-area {
    width: 85%;
    background-color: white;
    height: auto;
  }
  #all-panels {
    width: 95%;
  }
}
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .set-vcard-height {
    height: 320px;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import * as easings from "vuetify/lib/services/goto/easing-patterns";
import top_card from "../components/top_card.vue";
const titlecard = () => import("./titlecard.vue");

const rec_pub_recs_req = () => import("./rec_pub_recs_req.vue");
const rec_doc_ret_guide = () => import("./rec_doc_ret_guide.vue");
const rec_warrant_status = () => import("./rec_warrant_status.vue");
const rec_city_alarm = () => import("./rec_city_alarm.vue");
const rec_crmnl_hstry = () => import("./rec_crmnl_hstry.vue");
const rec_dptch_rcrds = () => import("./rec_dptch_rcrds.vue");
const rec_fbi_cde = () => import("./rec_fbi_cde.vue");
const rec_fee_schdl = () => import("./rec_fee_schdl.vue");
const rec_phn_num_hrs = () => import("./rec_phn_num_hrs.vue");
const rec_workcards_link = () => import("./rec_workcards_link.vue");
const rec_traff_rpt_lib = () => import("./rec_traff_rpt_lib.vue");
const rec_faq = () => import("./rec_faq.vue");
//
// import xtabs from "./xtabs.vue";
//import auth from "./auth.vue";

export default {
  name: "Home",
  components: {
    top_card,
    titlecard,
    rec_pub_recs_req,
    rec_doc_ret_guide,
    rec_warrant_status,
    rec_city_alarm,
    rec_crmnl_hstry,
    rec_dptch_rcrds,
    rec_fbi_cde,
    rec_fee_schdl,
    rec_phn_num_hrs,
    rec_traff_rpt_lib,
    rec_workcards_link,
    rec_faq,
  },
  mixins: [bus_common],
  data() {
    // Status, Fname, Lnprivateame, DOB, DIVISION
    return {
      descr_text:
        "The Records Division is responsible for maintaining internal document control over all original reports, including all crime,              arrest and traffic accident reports which are received by the              Department. This Division's personnel provide copy distribution,              confirmation of warrants and dissemination of documents and information per court order, state statute, and internal policy.",
    };
  },
  watch: {
    // "$store.state.user": function () {
    //   //keep this
    //   let self = this;
    //   this.init();
    // },
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    fabup(event) {
      const bdy = document.getElementsByClassName("bodyback")[0];
      bdy.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      document.getElementById("fabup").blur();
    },
    onExpansionPanelClick(event) {
      var targetID = event.currentTarget.id;
      var self = this;
      if (
        event.currentTarget.classList.contains(
          "v-expansion-panel-header--active"
        )
      ) {
        console.log("Panel is closing/now closed.");
      } else {
        console.log("Panel is opening/now open.");
        setTimeout(
          function () {
            //   window.scroll(0, 3500);
            console.log(targetID);
            const daWindow = document.getElementById("vapp");
            const element = document.getElementById(targetID);
            element.scrollIntoView({ behavior: "smooth" });
          },
          500,
          targetID
        );
      }
    },
    init(self) {
      this.show_loader(false);
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
